<template>
  <div class="teen-welcome-bar">
    <span class="welcome-user" v-if="username">欢迎，{{ username }}<router-link class="profile-link" to="/profile">个人中心 ›</router-link></span>
    <span
      :class="['teen-status-tag', isTeenagerMode ? 'teen-on' : 'teen-off']"
      @click="$root.$emit('teen-badge-click')"
    >
      <i class="teen-dot"></i>{{ isTeenagerMode ? '青少年模式已开启' : '开启青少年模式' }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.teen-welcome-bar {
  max-width: 1000px;
  width: 100%;
  margin: 12px auto 0;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.welcome-user {
  font-size: 14px;
  color: #666;

  .profile-link {
    color: #20a0ff;
    margin-left: 8px;
    cursor: pointer;
    text-decoration: none;
  }
}

.teen-status-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;

  &.teen-off {
    background: #f5f5f5;
    color: #999;
    border: 1px solid #e0e0e0;

    .teen-dot { background: #bbb; }
  }

  &.teen-on {
    background: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #a5d6a7;

    .teen-dot { background: #4caf50; }
  }

  .teen-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 5px;
    flex-shrink: 0;
  }
}
</style>

<script>
export default {
  name: 'TeenWelcomeBar',
  data() {
    return {
      isTeenagerMode: false,
      username: '',
    }
  },
  created() {
    this.refresh()
    if (this.$root && this.$root.$on) {
      this.$root.$on('account-changed', this.refresh)
      this.$root.$on('logout', this.refresh)
      this.$root.$on('userinfo-updated', this.refresh)
    }
  },
  beforeDestroy() {
    if (this.$root && this.$root.$off) {
      this.$root.$off('account-changed', this.refresh)
      this.$root.$off('logout', this.refresh)
      this.$root.$off('userinfo-updated', this.refresh)
    }
  },
  methods: {
    refresh() {
      this.isTeenagerMode = localStorage.getItem('teenagerMode') === 'true'
      try {
        const raw = sessionStorage.getItem('userinfo')
        const u = raw ? JSON.parse(raw) : null
        this.username = (u && u.name) || ''
      } catch (e) {
        this.username = ''
      }
    },
  },
}
</script>
